
var Job = require('./job');
var logger = require("../logger/logger");
var stringUtil = require("../string/stringUtil");

var jobs = [];
var timer;


export function addJob (id, name, func, isDelayed = false, onFailure = null, onSuccess = null, noOfMaximumExecutions = 5)
{
    var job = new Job();
    job.id = id;
    job.name = name;
    job.func = func;
    job.noOfMaximumExecutions = noOfMaximumExecutions;
    job.onFailure = onFailure;
    job.onSuccess = onSuccess;

    jobs = jobs.filter(j => !stringUtil.areStringSame(j.id, job.id));
    if (isDelayed)
    {
        jobs.push(job);
        setTimer();
        return;
    }
    
    executeJob(job, true);
}

function setTimer()
{
    if (timer == null && jobs.length > 0)
    {
        timer = window.setTimeout(()=>
        {
            executeJobs()
        }, 5000);
    }
}

async function executeJobs()
{
    timer = null;

    var clonedCopy = jobs;
    jobs = [];

    for (var index = 0; index < clonedCopy.length; index++)
    {
        var job = clonedCopy[index];
        await executeJob(job, false);
    }
    
    setTimer();
}



async function executeJob (job, activateTimer)
{
    try
    {
        job.noOfCurrentExecutions = job.noOfCurrentExecutions + 1;
        logger.info(`Running job with with id: ${job.id}, name: ${job.name} and attempt: ${job.noOfCurrentExecutions}.`);

        await job.func();
        logger.info(`Successfully executed job with with id: ${job.id}, name: ${job.name} and attempt: ${job.noOfCurrentExecutions}.`);
        await callOnSuccess(job);
    }
    catch(error)
    {
        logger.error(`Error occurred while running job with id: ${job.id}, name: ${job.name} and attempt: ${job.noOfCurrentExecutions}: ${error}.`, null, error);

        if (job.noOfCurrentExecutions >= job.noOfMaximumExecutions)
        {
            logger.error(`No further attempts will be made for job with id: ${job.id}, name: ${job.name}`);
            await callOnFailure(job);
        }
        else
        {
            logger.info(`Adding job again in queue for later attempt with id: ${job.id} and name: ${job.name}.`);  
            jobs.push(job);
        }
    }

    if (activateTimer)
        setTimer();
}

async function callOnFailure(job)
{
    try
    {
        if (job.onFailure == null)
            return;

        logger.info(`Running job onFailure with with id: ${job.id} and name: ${job.name}.`);
        await job.onFailure();
        logger.info(`Successfully executed job onFailure with with id: ${job.id} and name: ${job.name}.`);
    }
    catch(error)
    {
        logger.error(`Error occurred while calling job onFailure with with id: ${job.id} and name: ${job.name}: ${error}`, null, error)
    }
}

async function callOnSuccess(job)
{
    try
    {
        if (job.onSuccess == null)
            return;

        logger.info(`Running job onSuccess with with id: ${job.id} and name: ${job.name}.`);
        await job.onSuccess();
        logger.info(`Successfully executed job onSuccess with with id: ${job.id} and name: ${job.name}.`);
    }
    catch(error)
    {
        logger.error(`Error occurred while calling job onSuccess with with id: ${job.id} and name: ${job.name}: ${error}`, null, error)
    }
}